import React, { useEffect, useState } from 'react';
import { MIcon } from '../../lib/micon';
import { schuljahrKurz } from '../../lib/schuljahr';
import { apiPost } from '../../lib/api';
import { toast } from '../../lib/toast';
import { notenFarbeKMK } from '../../lib/utils';
import { LdSheet } from '../../components/ui/LdSheet';
import { LdSheetHeader, LdField, LdGradePicker, LdSheetSaveBar } from '../../components/ld/LdForm';

// Welle N2: „HJ1-Endnote fehlt · Jetzt eintragen“. Halbjahr 2 wird mit der EIGENEN HJ1-Endnote
// desselben Schuljahrs verrechnet (50/50). Nach einem Lehrer- oder Schulwechsel trägt die neue
// Lehrkraft hier die HJ1-Note aus dem Zeugnis ein — es gibt keine zweite Quelle.
export function Hj1EndnoteSheet({ open, schueler, klasseId, fach, schuljahr, onClose, onGespeichert }: {
  open: boolean;
  schueler: { id: number; name: string } | null;
  klasseId: number | null;
  fach: string;
  schuljahr: string;
  onClose: () => void;
  onGespeichert: () => void;
}) {
  const [wert, setWert] = useState(3);
  const [laden, setLaden] = useState(false);
  const [fehler, setFehler] = useState('');
  useEffect(() => { if (open) { setWert(3); setFehler(''); } }, [open]);

  async function speichern() {
    if (!schueler || !klasseId) return;
    setLaden(true); setFehler('');
    try {
      await apiPost('/api/halbjahres-note', { schueler_id: schueler.id, klasse_id: klasseId, fach, halbjahr: 'HJ1', schuljahr, endnote: wert });
      toast('HJ1-Endnote gespeichert', 'success');
      onGespeichert();
    } catch (err: any) { setFehler(err?.message ?? 'Speichern fehlgeschlagen.'); }
    finally { setLaden(false); }
  }

  return (
    <LdSheet open={open} onClose={onClose} maxWidth={440} ariaLabel="HJ1-Endnote eintragen">
      <div style={{ padding: '8px 24px 24px', display: 'flex', flexDirection: 'column', gap: 16 }}>
        <LdSheetHeader icon={<MIcon name="workspace_premium" size={20} />} title="HJ1-Endnote eintragen"
          subtitle={`${schueler?.name ?? ''} · ${fach} · Schuljahr ${schuljahrKurz(schuljahr)}`} onClose={onClose} />
        <p style={{ margin: 0, fontSize: 13, lineHeight: 1.5, color: 'var(--ld-text-secondary)' }}>
          Die Note aus dem Halbjahreszeugnis. Halbjahr 2 wird zur Hälfte mit ihr verrechnet. Hast du die Klasse neu übernommen, trag hier die Note aus dem Zeugnis ein.
        </p>
        <LdField label="Endnote Halbjahr 1" error={fehler || undefined}>
          <LdGradePicker value={wert} onChange={setWert} farbeFn={notenFarbeKMK} />
        </LdField>
        <LdSheetSaveBar onClick={speichern} disabled={!schueler || !klasseId} loading={laden}>{`Endnote ${wert} speichern`}</LdSheetSaveBar>
      </div>
    </LdSheet>
  );
}
